import { message, Spin } from "antd";
import qs from "qs";
import React, { useEffect, useState } from "react";
import TrackingTemplete from "../../components/TrackingTemplete";
import { DsersTrackingCoreV1GetTrackingPageInlineReply } from "../../components/TrackingTemplete/interface";
const currenctColor: Record<string, string> = {
  ColorSet_Black: "#25282C",
  ColorSet_Blue: "#3D5AFE",
  ColorSet_Green: "#495242",
  ColorSet_Nil: "#25282C",
};
export const PublicTracking = React.memo(() => {
  const [renderData, setRenderData] =
    useState<DsersTrackingCoreV1GetTrackingPageInlineReply>(
      {} as DsersTrackingCoreV1GetTrackingPageInlineReply,
    );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTempleteData();
  }, []);

  const getTempleteData = async () => {
    setLoading(true);
    const query = qs.parse(window.location.search.slice(1));
    console.log("process.env.NODE_ENV::", process.env.NODE_ENV);
    const { hostname } = window.location;

    const prefix =
      hostname.includes("dev.dsers.com") || hostname.includes("localhost")
        ? "https://bff-api-gw-test.dsers.com"
        : "https://bff-api-gw.dsers.com";

    try {
      const res = await fetch(
        `${prefix}/dsers-tracking-bff/tracking-page/outside/get?userId=${query.userid}&storeId=${query.storeid}`,
      );

      const data = await res.json();
      const isErrorEmail = Object.prototype.hasOwnProperty.call(
        data.data || {},
        "isErrorEmail",
      )
        ? data.data.isErrorEmail
        : true;
      // setRenderData({
      //   ...data.data,
      //   color: currenctColor?.[data.data?.color ?? "ColorSet_Nil"],
      //   isErrorEmail,
      // });
      setRenderData(data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("Failed to obtain logistics information");
    }
  };

  return (
    <div style={{ maxWidth: "803px", margin: "64px auto" }}>
      {loading ? (
        <Spin spinning={loading}>
          <div style={{ height: "100vh", width: "100vw" }}></div>
        </Spin>
      ) : (
        <TrackingTemplete
          changeBackgroundColor
          from="dsers"
          productLoading={loading}
          loading={loading}
          renderData={renderData}
        />
      )}
    </div>
  );
});
